import { IMerchant } from "@/i/merchant";

export const merchantFactory = (merchant): IMerchant => {
  return {
    id: merchant.store_url,
    logo: merchant.logo,
    name: merchant.name,
    monetizedLink: merchant.monetized_link
  };
};
